import { api } from "./api";

const unitApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllUnit: builder.query({
      query: () => "unit",
      providesTags: ["unit"],
    }),
    addUnit: builder.mutation({
      query: (newCategory) => ({
        url: "unit",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["unit"],
    }),
    removeUnit: builder.mutation({
      query: (id) => ({
        url: `unit/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["unit"],
    }),
    editUnit: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/unit/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["unit"],
    }),
  }),
});

export const {
  useGetAllUnitQuery,
  useAddUnitMutation,
  useRemoveUnitMutation,
  useEditUnitMutation,
} = unitApi;
